import React, { useRef, useEffect, useState } from "react";
import { Button, Image, Input, InputNumber, Modal, Switch, Upload } from "antd"
import TextArea from "antd/lib/input/TextArea"
import { useAddUpdateBannerHook } from "../../hooks"
import { beforeUpload } from "../../utils/common.utils"
import { Add } from "@material-ui/icons";
import "./banners.css"
import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
import { Select } from "antd"
import { SelectDropDown } from "../SelectDropDown/SelectDropDown";

export const AddUpdateBannerModal = ({
   selectedBannerData = {},
   isModalOpen = false,
   isEdit = false,
   handleSubmit = () => { },
   handleCloseModal = () => { }
}) => {
   const {
      isLoading,
      bannerData,
      errorMessages,
      bannerInputData,
      handleSearchChange,
      handleInputChange,
      handleSelectChange,
      handleSwitchChange,
      handleBannerSubmit,
      handleUploadImage,
      handleRemoveImage
   } = useAddUpdateBannerHook({
      selectedBannerData,
      isModalOpen,
      isEdit,
      handleSubmit,
   })

   const uploadButton = (
      <div>
         <Add />
         <div style={{ marginTop: 8 }}>Upload</div>
      </div>
   );

   const redirectionTypeList = [
      {
         label: "Seller",
         value: "seller"
      },
      {
         label: "Category",
         value: "category"
      }
   ]





   //  HERO SEARCH BAR JS START
   const [isOpen, setIsOpen] = useState(false);
   const searchBarRef = useRef(null);

   const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
         setIsOpen(false); // Close the search bar if clicking outside
      }
   };

   useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
         document.removeEventListener("mousedown", handleClickOutside);
      };
   }, []);
   // HERO SEARCH BAR JS END

   const [searchText, setSearchText] = useState('');











   const [selectedValue, setSelectedValue] = useState('');  // Store selected option
   const [loading, setLoading] = useState(false);  // Show loading when fetching

   return (
      <Modal
         visible={isModalOpen}
         closable={true}
         title={isEdit ? "Edit Banner" : "Add Banner"}
         onCancel={() => handleCloseModal(false)}
         footer={[
            <Button
               className={'ml-2'}
               key="back"
               onClick={() => handleCloseModal(false)}
            >
               Cancel
            </Button>,
            <Button
               className={'ml-2'}
               key="submit"
               type="primary"
               loading={isLoading}
               onClick={() => handleBannerSubmit()}
            >
               Submit
            </Button>
         ]}
      >
         <div>
            <div className='mb-3'>
               <div>Banner Name : </div>
               <Input
                  name={"name"}
                  value={bannerData.name || ""}
                  placeholder="Enter a banner name"
                  maxLength={16}
                  onChange={handleInputChange}
               />
               {errorMessages.name && <span className='error-message'>{errorMessages.name}</span>}
            </div>

            {/* <div className='mb-3'>
               <div>Categories : </div>
               <Select
                  mode="multiple"
                  allowClear
                  style={{
                     width: '100%',
                  }}
                  placeholder="Please select category"
                  value={bannerData.categories || []}
                  onChange={(value) => handleSelectChange(value, "categories")}
                  options={options.categories || []}
               />
            </div> */}

            <div className='mb-3 flex'>
               <div>
                  <div>Banner Image : </div>
                  <div className="banner-upload-wraper">
                     <Upload
                        name="banner_image"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={handleUploadImage}
                     >
                        {bannerData.banner_image && (bannerData.banner_image.base64url || bannerData.banner_image.url)
                           ?
                           <>
                              <Image
                                 className="banner-image"
                                 preview={false}
                                 src={bannerData.banner_image.base64url || bannerData.banner_image.url}
                                 alt="banner-image"
                                 style={{ width: '100%' }} />
                           </>

                           : uploadButton
                        }
                     </Upload>
                     {bannerData.banner_image && (bannerData.banner_image.base64url || bannerData.banner_image.url)
                        &&
                        <div className="delete-img-wrap" onClick={handleRemoveImage}>
                           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.75 6.16667C2.75 5.70644 3.09538 5.33335 3.52143 5.33335L6.18567 5.3329C6.71502 5.31841 7.18202 4.95482 7.36214 4.41691C7.36688 4.40277 7.37232 4.38532 7.39185 4.32203L7.50665 3.94993C7.5769 3.72179 7.6381 3.52303 7.72375 3.34536C8.06209 2.64349 8.68808 2.1561 9.41147 2.03132C9.59457 1.99973 9.78848 1.99987 10.0111 2.00002H13.4891C13.7117 1.99987 13.9056 1.99973 14.0887 2.03132C14.8121 2.1561 15.4381 2.64349 15.7764 3.34536C15.8621 3.52303 15.9233 3.72179 15.9935 3.94993L16.1083 4.32203C16.1279 4.38532 16.1333 4.40277 16.138 4.41691C16.3182 4.95482 16.8778 5.31886 17.4071 5.33335H19.9786C20.4046 5.33335 20.75 5.70644 20.75 6.16667C20.75 6.62691 20.4046 7 19.9786 7H3.52143C3.09538 7 2.75 6.62691 2.75 6.16667Z" fill="currentColor" />
                              <path className="trash-path-2" opacity="1" d="M11.6068 21.9998H12.3937C15.1012 21.9998 16.4549 21.9998 17.3351 21.1366C18.2153 20.2734 18.3054 18.8575 18.4855 16.0256L18.745 11.945C18.8427 10.4085 18.8916 9.6402 18.45 9.15335C18.0084 8.6665 17.2628 8.6665 15.7714 8.6665H8.22905C6.73771 8.6665 5.99204 8.6665 5.55047 9.15335C5.10891 9.6402 5.15777 10.4085 5.25549 11.945L5.515 16.0256C5.6951 18.8575 5.78515 20.2734 6.66534 21.1366C7.54553 21.9998 8.89927 21.9998 11.6068 21.9998Z" fill="currentColor" />
                           </svg>
                        </div>
                     }
                  </div>
                  {errorMessages.banner_image && <span className='error-message'>{errorMessages.banner_image}</span>}
               </div>

               <div className='w-100'>
                  <div>Description</div>
                  <TextArea
                     name={"description"}
                     value={bannerData.description || ""}
                     placeholder="Enter banner description"
                     rows={4}
                     onChange={handleInputChange}
                  />
                  {errorMessages.description && <span className='error-message'>{errorMessages.description}</span>}
               </div>
            </div>










            <div className='mb-3'>
               <div>Redirection Type : </div>
               <Select
                  allowClear
                  style={{
                     width: '100%',
                  }}
                  placeholder="Please select category"
                  value={bannerData.redirection_type || null}
                  onSearch={(text) => {
                     console.log({ searchText: text });
                  }}
                  // onClear={ () => {
                  //    handleSelectChange(null, "redirection_type")
                  //    // handleSelectChange([], "redirection_data")
                  // }}
                  onSelect={(value) => {
                     // handleSelectChange(value, "redirection_type");
                     // handleSelectChange([], "redirection_data") 
                  }}
                  onChange={(value) => {
                     handleSelectChange(value, "redirection_type");
                     // handleSelectChange([], "redirection_data") 
                  }}
                  options={redirectionTypeList || []}
               />
            </div>




            {console.log({ bannerInputData: bannerInputData })}
            {bannerData.redirection_type && (
               bannerData.redirection_type == 'seller' ?
                  (
                     <div className='mb-3'>
                        <div>Select Seller : </div>
   
                        <div className="custom-search-select-dropdown mb-3">
                           <div onClick={() => setIsOpen(true)} className="w-100 h-100">
                              {bannerData?.redirection_data && String(bannerData?.redirection_data?.length) > 0 ? (
                                 bannerInputData?.sellerData.filter((seller) =>
                                    String(bannerData?.redirection_data).split(',').includes(String(seller.value))
                                 ).map((seller) => (
                                    <div className="selected-item">
                                       <div key={seller.value} className="seller-item">
                                          {seller.label}
                                          <span
                                             className="clear-icon"
                                             onClick={() => {
   
                                                // let selectedValues = String(bannerData?.redirection_data).split(',').map(val => val.trim());
                                                // selectedValues = selectedValues.filter(val => val !== String(seller.value));
                                                // const result = selectedValues.filter(val => val).join(',');
   
                                                const result = [];
                                                handleSelectChange(result, "redirection_data");
                                             }}
                                          >&times;</span> {/* Cross Icon */}
                                       </div>
                                       <icon name="cross"></icon>
                                    </div>
                                 ))
                              ) : (
                                 <input
                                    allowClear
                                    type="search"
                                    // value={bannerData.redirection_data || null}
                                    className="ant-input"
                                    onChange={handleSearchChange}
                                 />
                              )}
                           </div>
   
                           <div
                              ref={searchBarRef}
                              className={`${isOpen ? "openHeroSearchBarListWrap" : ""} custom-select-dropdown-menu `}>
                              {bannerInputData.sellerData.map((data, index) => (
                                 <div className="select-option-li" >
                                    {/* <input type="checkbox" */}
                                    <input type="radio"
                                       id={data.value}
                                       name="fav_select"
                                       value={data.value}
                                       // checked={String(bannerData?.redirection_data).split(',')?.includes(data.value)}
                                       checked={String(bannerData?.redirection_data).split(',')?.includes(String(data.value))}
                                       onChange={(event) => {
   
                                          // let selectedValues = bannerData?.redirection_data ? String(bannerData?.redirection_data).split(',').map(val => val.trim()) : [];
                                          // if (selectedValues.includes(String(data.value))) {
                                          //    selectedValues = selectedValues.filter(val => val !== String(data.value));
                                          // } else {
                                          //    selectedValues.push(String(data.value));
                                          // }
                                          // const result = selectedValues.filter(val => val).join(',');
   
                                          const result = [data.value];
                                          handleSelectChange(result, "redirection_data");
                                       }}
                                    />
                                    <label for={data.value}>
                                       {data.label}
                                    </label>
                                 </div>
                              ))}
                           </div>
   
                        </div>
   
                        {selectedValue && <p>You selected: {selectedValue}</p>}
                        {errorMessages.redirection_type && <span className='error-message'>{errorMessages.redirection_data}</span>}
                     </div>
                  ) : (
                     <div className='mb-3'>
                        <div>Select Categories :</div>
                        <div className="custom-search-select-dropdown mb-3">
                           <div onClick={() => setIsOpen(true)} className="w-100 h-100 select-category-section">
                              <input
                                 allowClear
                                 type="search"
                                 // value={bannerData.redirection_data || null}
                                 className="ant-input"
                                 onChange={(event) => {
                                    console.log(event.target.value);
                                    setSearchText(event.target.value)
                                 }}
                              />
   
                              {bannerInputData?.categoryData?.filter((category) => bannerData?.redirection_data?.includes(String(category.value))
                                 // bannerData.redirection_data == seller.value
                              )?.map((category) => (
                                 <div className="selected-item">
                                    <div key={category.category} className="seller-item">
                                       {category.label}
                                       <span
                                          className="clear-icon"
                                          onClick={() => {
   
                                             let selectedValues = String(bannerData?.redirection_data).split(',').map(val => val.trim());
                                             selectedValues = selectedValues.filter(val => val !== String(category.value));
                                             const result = selectedValues.filter(val => val).join(',');
   
                                             handleSelectChange(result, "redirection_data");
                                          }}
                                       >&times;</span>
                                    </div>
                                    <icon name="cross"></icon>
                                 </div>
                              ))}
                           </div>
   
                           <div
                              ref={searchBarRef}
                              className={`${isOpen ? "openHeroSearchBarListWrap" : ""} custom-select-dropdown-menu `}>
                              {
                                 (bannerInputData?.categoryData?.filter((category) => {
                                    if (searchText) {
                                       return category.label.toLowerCase().includes(searchText.toLowerCase()); // Case-insensitive search
                                    }
                                    return true;
                                 }))?.map((data, index) => (
                                    <div className="select-option-li" >
                                       <input type="checkbox"
                                          // <input type="radio"
                                          id={data.value}
                                          name="fav_select"
                                          value={data.value}
                                          // checked={String(bannerData?.redirection_data).split(',')?.includes(data.value)}
                                          checked={String(bannerData?.redirection_data).split(',')?.includes(String(data.value))}
                                          onChange={(event) => {
                                             let selectedValues = bannerData?.redirection_data ? String(bannerData?.redirection_data).split(',').map(val => val.trim()) : [];
                                             if (selectedValues.includes(String(data.value))) {
                                                selectedValues = selectedValues.filter(val => val !== String(data.value));
                                             } else {
                                                selectedValues.push(String(data.value));
                                             }
                                             const result = selectedValues.filter(val => val).join(',');
                                             handleSelectChange(result, "redirection_data");
                                          }}
                                       />
                                       <label for={data.value}>
                                          {data.label}
                                       </label>
                                    </div>
                                 ))}
                           </div>
                        </div>
   
                        {errorMessages.redirection_type && <span className='error-message'>{errorMessages.redirection_data}</span>}
                     </div>
                  )
               
            )}


            <div className='mb-3'>
               <div>Banner Order Number : </div>
               <InputNumber
                  className="w-100"
                  defaultValue={1}
                  name="sort_order_by"
                  value={bannerData.sort_order_by || 0}
                  onChange={(value) => handleSelectChange(value, "sort_order_by")}
               />
               {errorMessages.sort_order_by && <span className='error-message'>{errorMessages.sort_order_by}</span>}
            </div>

            <div className="flex mb-3">
               <Switch
                  checked={bannerData.status === "true" || bannerData.status === true || false}
                  onChange={(isChecked) => handleSwitchChange(isChecked, "status")}
               />
               <div className="mx-2">Do you want to make this banner active ?</div>
            </div>

         </div >
      </Modal >
   )
}